<template>
  <div class="color-scale-input">
    <div v-if="allowCategorical" class="mode-option">
      <input
        id="notcategorical"
        type="radio"
        :value="isCategorical"
        :checked="!isCategorical"
        @click="isCategorical=false"
      >
      <label for="notcategorical">
        {{ $t('colors_by_value') }}
      </label>
    </div>
    <!-- <template v-if="!isCategorical"> -->
    <div class="gradient-inputs" :class="{disabled: isCategorical, indented:allowCategorical}">
      <ColorPickerInput v-model="colorPicked" :options="colorsObject" />
      <CheckboxInput v-model="flipColors" text="color_flip" class="flip-check" />
      <RadioScaleInput
        v-model="internalValue"
        :all-time-values="allTimeValues"
      />
      <OpacityRangeInput v-if="transparencyEnabled" v-model="gradientInternalValue.opacityMapValue" />
    </div>
    <div v-if="allowCategorical" class="mode-option">
      <input
        id="categorical"
        type="radio"
        :value="isCategorical"
        :checked="isCategorical"
        @click="isCategorical=true"
      >
      <label for="categorical">
        {{ $t('colors_by_category') }}
      </label>
    </div>
  </div>
</template>

<script>
import ColorPickerInput from './ColorPickerInput.vue'
import OpacityRangeInput from './OpacityRangeInput.vue'
import RadioScaleInput from './RadioScaleInput.vue'
import CheckboxInput from '../charts/CheckboxInput.vue'
import { format as d3_format } from 'd3-format'

import { cssGradient, MAP_COLORS } from '../../utils/colorUtils'
export default {
  components: { ColorPickerInput, OpacityRangeInput, RadioScaleInput, CheckboxInput },
  model: {
    prop: 'colorConfig',
    event: 'change',
  },
  props: {
    colorConfig: [Object, String],
    allTimeValues: Array,
    allowCategorical: Boolean,
    transparencyEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isCategorical: this.allowCategorical,
      flipColors: false,
      internalValue: null,
      // internalValue.scaleSteps: 5,
      // internalValue.interpolationType: 'linear',
      // internalValue.scaleOption: 'gradient',
      // colorPicked: Object.keys(MAP_COLORS)[0],
      // hasLegend: true,
      colorsObject: MAP_COLORS,
      // opacityMapValue: 50,
      dummyGradientSettings: {
        scaleSteps: 5,
        interpolationType: 'linear',
        scaleOption: 'gradient',
        opacityMapValue: 100,
        colorRange: ['#BBD6E8', '#15537E'],
        customSteps: null,
      },
    }
  },
  computed: {
    colorPicked: {
      get() {
        return Object.keys(MAP_COLORS).find(key => {
          return (
            JSON.stringify(MAP_COLORS[key]) ===
            JSON.stringify(this.gradientInternalValue.colorRange)
          )
        })
      },
      set(key) {
        this.internalValue.colorRange = MAP_COLORS[key]
      },
    },
    gradientInternalValue() {
      if (this.isCategorical) {
        return this.dummyGradientSettings
      } else {
        return this.internalValue
      }
    },
  },
  watch: {
    // colorPicked(v) {
    //   this.internalValue.colorRange = this.colorsObject[v]
    // },
    isCategorical() {
      if (this.isCategorical) {
        this.dummyGradientSettings = JSON.parse(JSON.stringify(this.internalValue))
        this.internalValue = 'categorical'
      } else {
        this.internalValue = this.dummyGradientSettings
      }
    },
    flipColors() {
      this.internalValue.colorRange = MAP_COLORS[this.colorPicked].reverse()
    },
    colorConfig: {
      handler(value) {
        let tmp = JSON.parse(JSON.stringify(value))
        this.internalValue = tmp
      },
      immediate: true,
      deep: true,
    },
    internalValue: {
      handler(value) {
        if (JSON.stringify(value) !== JSON.stringify(this.colorConfig)) this.$emit('change', value)
      },
      deep: true,
    },
  },
  methods: {
    cssGradient,
    d3_format,
    // changeNumSteps(num) {
    //   this.internalValue.scaleSteps = parseInt(num)
    // },
    // changeInterpolation(value) {
    //   this.internalValue.interpolationType = value
    // },
  },
}
</script>

<style lang="stylus" scoped>
.mode-option
  display: flex
  align-items: flex-start
  margin-bottom: vw(10px)

  label
    margin-left: vw(4px)
    cursor: pointer

  input
    cursor: pointer

.gradient-inputs
  &.indented
    margin-left: vw(20px)

  &.disabled
    opacity: 0.3
    pointer-events: none

.color-scale-input
  margin-bottom: vw(15px)

  .flip-check
    margin-top: vw(20px)
</style>
